import React from "react"
import {IconWrapper} from "./component"
import connect from "./connect"

export type SecureIconProps = {
    icon: string | null
}

export const SecureIcon = ({icon}: SecureIconProps) => {
    return icon ? (
        <IconWrapper data-testid="header-secure-icon" className="header-secure-icon">
            <svg
                width="24"
                height="24"
                data-testid="header-secure-icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <use className="default" href={`${icon}#default`} />
            </svg>
        </IconWrapper>
    ) : null
}

export default connect(SecureIcon)
